<template>
  <z-dialogo ref="dialogo" titulo="Imprimir caixa do dia" :dividers="true" largura="500px" persistent>
    <template #conteudo>
      <v-row dense>

        <v-col sm="12">
          <v-radio-group
            v-model="filtro.impressao"
            label="Imprimir"
            class="mt-0 pt-0"
            @change="filtro.vendedor_id = ''; filtro.terminal = ''"
          >
            <v-radio
              color="primary"
              :label="`Meu caixa (${ $auth.user.name })`"
              value="meucaixa"
            ></v-radio>
            <v-radio
              color="primary"
              label="Caixa Geral"
              value="geral"
              class="mt-2"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="6">
          <z-select 
            v-model="filtro.vendedor_id"
            clearable
            label="Vendedor (Opcional)"
            :items="vendedores"
            :disabled="filtro.impressao === 'meucaixa'"
          ></z-select>
        </v-col>
        <v-col cols="6">
          <z-select 
            v-model="filtro.terminal"
            label="Terminal"
            placeholder=" "
            clearable
            :items="terminais" 
            :disabled="filtro.impressao === 'meucaixa'"
            @click:clear="filtro.terminal = ''"
          ></z-select>
        </v-col>
      </v-row>
    </template>

    <template #actions_right>
      <v-btn text @click="$refs.dialogo.fechar()">
        Cancelar
      </v-btn>
      <v-btn depressed color="primary" @click="imprimir">
        <v-icon left>mdi-printer</v-icon>
        Imprimir
      </v-btn>
    </template>
  </z-dialogo>
</template>

<script>
import { gerarTerminais, parseParams } from '@/app/helpers/utils';

export default {
  name: 'CaixaDiario',

  props: {
    data: {
      type: String,
      default: '',
    },
  },

  inject: ["$imprimir"],

  data() {
    return {
      aberto: false,
      filtro: {
        vendedor_id: '',
        impressao: 'meucaixa',
        terminal: '',
      },
      meses: this.$globals.MESES,
      vendedores: [],
    };
  },

  computed: {
    terminais() {
      return gerarTerminais();
    },
  },

  methods: {
    async abrir() {
      await this.$store.dispatch("listas/vendedores");
      this.$refs.dialogo.abrir();
      this.vendedores = this.$store.getters["listas/vendedores"];
    },

    fechar() {
      this.$refs.dialogo.fechar();
    },

    imprimir() {
      this.$emit('imprimir', this.filtro);
      // this.$imprimir(`relatorios/caixa/imprimir?data=${this.data}&` + new URLSearchParams(parseParams(this.filtro)).toString());
    },
  },
};
</script>

<style scoped></style>
